import {IUserAuthenticationRestClient} from "./i-user-authentication-rest.client";
import {Injectable} from "@angular/core";
import {firstValueFrom, Observable} from "rxjs";
import { HttpClient } from "@angular/common/http";
import {IOkResponse} from "@zaeper/communication-lib";
import {HostUtil} from "../../../utils/host-util";
import {ARestClient} from "@zaeper/communication-lib";
import {LocalstorageUtil} from "@zaeper/core-lib";
import {ICurrentUser} from "../../../models/i-current-user";
import {IDeveloperRegistrationRequest} from "./requests/i-developer-registration-request";
import {ISlugAvailability} from "./responses/i-slug-availability";

@Injectable()
export class UserAuthenticationRestClient extends ARestClient implements IUserAuthenticationRestClient {
  constructor(private _httpClient: HttpClient) {
    super();
  }

  public getCurrentUser(): Promise<ICurrentUser> {
    const endpointUrl: string = super.getEndpointUrl(HostUtil.getUserApiEndpointUrl(), "v1/current-user");

    return firstValueFrom(this._httpClient.get(endpointUrl, {withCredentials: true}) as Observable<ICurrentUser>);
  }

  public registerDeveloper(request: IDeveloperRegistrationRequest): Promise<ICurrentUser> {
    const endpointUrl: string = super.getEndpointUrl(HostUtil.getUserApiEndpointUrl(), "v1/developer-registration");

    return firstValueFrom(this._httpClient.post(endpointUrl, request, {withCredentials: true}) as Observable<ICurrentUser>);
  }

  public activateDeveloperRegistration(): Promise<ICurrentUser> {
    const endpointUrl: string = super.getEndpointUrl(HostUtil.getUserApiEndpointUrl(), "v1/developer-registration/activate");

    return firstValueFrom(this._httpClient.post(endpointUrl, {}, {withCredentials: true}) as Observable<ICurrentUser>);
  }

  public checkSlugAvailability(slug: string): Promise<ISlugAvailability> {
    const endpointUrl: string = super.getEndpointUrl(HostUtil.getUserApiEndpointUrl(), "v1/developer-registration/slug-availability");

    return firstValueFrom(this._httpClient.get(endpointUrl, {params: {slug}, withCredentials: true}) as Observable<ISlugAvailability>);
  }

  public logout(): Promise<IOkResponse> {
    const endpointUrl: string = super.getEndpointUrl(HostUtil.getAuthenticationApiEndpointUrl(), "v1/logout");

      return firstValueFrom(this._httpClient.post(endpointUrl, {}, {
        withCredentials: true
      }) as Observable<IOkResponse>);
  }

  public updateColorSchemePreference(colorSchemePreference: string): Promise<IOkResponse> {
    const endpointUrl: string = super.getEndpointUrl(HostUtil.getAuthenticationApiEndpointUrl(), "v1/user/color-scheme-preference");

    return firstValueFrom(this._httpClient.put(endpointUrl, {colorSchemePreference}, {withCredentials: true}) as Observable<IOkResponse>);
  }
}
